import { lazy } from 'react';

const NewScenarioModal = lazy(
  () => import('./pages/SimulatorLandingPage/components/NewScenarioModal'),
);
const DeleteScenarioModal = lazy(
  () => import('./pages/SimulatorLandingPage/components/DeleteScenarioModal'),
);
const WhatDoTheseNumbersMean = lazy(
  () => import('./pages/Simulator/containers/WhatDoTheseNumbersMean'),
);

export default {
  DELETE_SCENARIO_MODAL: DeleteScenarioModal,
  NEW_SCENARIO_MODAL: NewScenarioModal,
  WHAT_DO_THESE_NUMBERS_MEAN: WhatDoTheseNumbersMean,
};
